/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { Component, createRef, ReactNode } from 'react'

import classNames from 'classnames'
import { createBrowserHistory } from 'history'
import { isEqual } from 'lodash'
import { Empty, Loader, Paginator } from 'shared/components'
import { DispatchQuery, getUpdateUrl } from 'shared/hooks'
import { getUrlParams } from 'shared/utils/getUrlParams'

import classes from './AbstractList.module.scss'

type State<T> = {
  items: T[]
  page: number
  more: boolean
  loading: boolean
  totalCount: number
  showItemsCount: number
  values: { [key: string]: string }
  [key: string]: any
}

export abstract class AbstractListClass<P, T> extends Component<P, State<T>> {
  constructor(props: P) {
    super(props)

    const params = getUrlParams()
    this.state = {
      items: [],
      values: params,
      page: this.getPageNumber(params?.page),
      more: false,
      loading: true,
      totalCount: 0,
      showItemsCount: 10,
    }
    // this.getList()
  }
  containerRef = createRef<HTMLDivElement>()
  history = createBrowserHistory()

  componentDidMount() {
    document.addEventListener(DispatchQuery, this.handleOnUrlChange)
  }
  componentWillUnmount() {
    document.removeEventListener(DispatchQuery, this.handleOnUrlChange)
  }

  handleOnUrlChange = () => {
    const values = getUrlParams()

    if (!isEqual(values, this.state.values)) {
      this.setState(
        { values, page: this.getPageNumber(values?.page), loading: true },
        () => this.getList()
      )
    }
  }

  getPageNumber(page?: string): number {
    const propsPage = page ?? this.state?.values?.page
    return propsPage ? Number(propsPage) : 1
  }

  getList() {}

  setDefault(items: T[], totalCount = 0): void {
    // const { items: _items, more } = this.state
    // const items = more ? _items.concat(resItems) : resItems

    this.setState({
      items,
      loading: false,
      more: false,
      totalCount,
    })
  }

  setValue(value: number, more: boolean): void {
    this.setState({ more }, () => {
      getUpdateUrl(
        { ...this.state.values, page: value.toString() },
        this.history.push
      )
      if (!more && this.containerRef.current) {
        this.containerRef.current?.scrollIntoView({ behavior: 'smooth' })
      }
    })
  }

  renderChildren(): ReactNode {
    return <></>
  }

  renderFooter(onMoreBtnClick?: () => void): JSX.Element {
    const { totalCount, page, showItemsCount } = this.state
    return (
      <div className="mt-2 mb">
        <Paginator
          withBtn
          totalCount={totalCount}
          showCount={showItemsCount}
          initialPage={page}
          onChange={(currentPage, s, m) =>
            this.setValue(currentPage, m ?? false)
          }
          onMoreBtnClick={() => onMoreBtnClick && onMoreBtnClick()}
        />
      </div>
    )
  }

  renderEmpty(): JSX.Element {
    return <Empty />
  }

  render(onMoreBtnClick?: () => void): JSX.Element {
    const { loading, items } = this.state

    const cn = classNames([
      classes.container,
      {
        [classes.visible]: loading,
      },
    ])
    if (!loading && !items?.length) {
      return this.renderEmpty()
    }
    return (
      <div className={cn} ref={this.containerRef}>
        {loading && <Loader size="full" />}
        {this.renderChildren()}
        {this.renderFooter(onMoreBtnClick)}
      </div>
    )
  }
}
